import type { TGender } from '~constants/gender';

import type {
	GridFiltersFormFields as fields,
	GridFiltersQueryParams as params,
} from './names';

export type DesireId = number;

export enum CreatedBy {
	all = 'all',
	community = 'community',
	celebrity = 'celebrity',
	eva = 'eva',
}

export const isCreatedBy = (value: string): value is CreatedBy =>
	[CreatedBy.community, CreatedBy.eva, CreatedBy.celebrity].includes(
		value as CreatedBy
	);

export type TGridFiltersFormValues = {
	[fields.gender]?: TGender | null;
	[fields.fromAge]?: number;
	[fields.toAge]?: number;
	[fields.createdBy]?: CreatedBy | null;
	[fields.keyword]?: string;
};

export type TGridFiltersValues = {
	[fields.gender]?: TGender;
	[fields.fromAge]?: number;
	[fields.toAge]?: number;
	[fields.createdBy]?: CreatedBy;
	[fields.keyword]?: string;
};

export type TGridFiltersQuery = {
	[params.page]?: string;
	[params.gender]?: TGender;
	[params.fromAge]?: string;
	[params.toAge]?: string;
	[params.createdBy]?: CreatedBy;
	[params.keyword]?: string;
};

export type GridFiltersModalProps = {
	opened: boolean;
	onClose: () => void;
};
